import React, { Component } from 'react'
import moment from 'moment'

class History extends Component {
    render() {
        console.log("row is here", this.props.row)
        const row = this.props.row 
        return (
            <div className="graphicas mt-3 ">
                <div className="history-group border p-3">
                    <div className="group my-4">
                        <p className="label-name"><strong>Data de submissão</strong></p>
                        <p className="graphicas-info">{moment(row['dataCriado']).format('DD/MM/YY')}</p>
                    </div>
                    <div className="group my-4">
                        <p className="label-name"><strong>Responsável do pedido</strong></p>
                        <p className="graphicas-info">{row['responsavelRececao'] ? row['responsavelRececao'] : "nd"}</p>
                    </div>
                    <div className="group my-4">
                        <p className="label-name"><strong>Estado da decisão</strong></p>
                        <p className="graphicas-info">{row['estadodadecisao'] ? row['estadodadecisao'] : "nd"}</p>
                    </div>
                </div>
            </div>
        )
    }
}
export default History